import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import * as Sentry from '@sentry/browser'

enum ErrorCodes {
  INVALID_JWT = 'invalid-jwt',
}

const handleErrorLink = onError(
  ({ operation, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach((error) => {
        switch (error.extensions.code) {
          case ErrorCodes.INVALID_JWT:
            if (process.env.NODE_ENV === 'development') {
              console.warn('JWT authentication failed, token removed.')
            }
            localStorage.removeItem('token')
            break
          default:
            if (process.env.NODE_ENV === 'development') {
              //Errors should be generally handled when getting the data, this is simply additional information
              //https://github.com/vacuumlabs/fine-tracker/pull/531#discussion_r425737187
              console.warn('[Apollo GraphQL error]:', operation, error)
            } else if (process.env.REACT_APP_SENTRY_DSN) {
              Sentry.captureException(error)
            }
            break
        }
      })
    }
    if (networkError) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[Apollo Network error]:', operation, networkError)
      }
    }
  }
)

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  }
})

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GQL_ENDPOINT,
})

export const client = new ApolloClient({
  link: ApolloLink.from([handleErrorLink, authLink, httpLink]),
  //TODO: improve cache setup
  cache: new InMemoryCache(),
})

export type TrackerApolloClient = typeof client
